// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 31) return "static/js/db33c0a4fe4a2d6173d5.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"319f1267e542695390db","135":"f7139ecd2c1942067d10","136":"fad5b3788bb1da4c214b"}[chunkId] + ".chunk.js";
};